import React, { useEffect } from 'react';
import { Drawer, IDrawerProps } from '@oliasoft-open-source/react-ui-library';

interface TabItem {
  icon: React.ReactNode;
  content: React.ReactNode;
}
interface GenericDrawerProps {
  right?: boolean;
  button?: boolean;
  width?: string;
  defaultTabIndex?: number;
  tabs?: TabItem[];
  onResize?: () => void;
}
export const GenericDrawer: React.FC<GenericDrawerProps> = ({
  right = true,
  button = false,
  width = '400px',
  defaultTabIndex = 0,
  tabs = [],
  onResize,
}) => {
  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
  }, [width]);

  const drawerTabs: IDrawerProps['tabs'] = tabs.map((tab) => ({
    icon: tab.icon,
    content: tab.content,
  }));
  return (
    <Drawer
      right={right}
      button={button}
      closedWidth={0}
      width={width}
      defaultTabIndex={defaultTabIndex}
      tabs={drawerTabs}
      onResize={onResize}
    />
  );
};
